module.exports = __webpack_public_path__ + "media/images/redesign-images/sorority/image-grid/grid-02-7d8b29c28b51f4bd3da0c0827a86d4de.jpg";